import { createFileRoute } from '@tanstack/react-router';
import { GroupsEmptyState } from '@pages/groups';

export const Route = createFileRoute('/_authenticated/groups/')({
  component: GroupsEmptyState,
});
